import { render, staticRenderFns } from "./MdFileEditor.vue?vue&type=template&id=6d0e130d&scoped=true"
import script from "./MdFileEditor.vue?vue&type=script&lang=js"
export * from "./MdFileEditor.vue?vue&type=script&lang=js"
import style0 from "./MdFileEditor.vue?vue&type=style&index=0&id=6d0e130d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e130d",
  null
  
)

export default component.exports